<template>
  <form @submit.prevent="submit">
    <div class="row justify-content-start">
      <div class="col-12">
        <fg-input :placeholder="$t('settings.products.rules.labels.product')"
                  required
                  :label="$t('settings.products.rules.labels.product')"
                  :error="getError($t('settings.products.rules.labels.product'))">
          <el-select v-model="model.product_id"
                     v-validate="validations.required"
                     :name="$t('settings.products.rules.labels.product')"
                     @change="getJobBoards"
                     class="select-default">
            <el-option v-for="jobBoard in products"
                       :label="jobBoard.name"
                       :value="jobBoard.id"
                       :key="jobBoard.id"
                       class="select-default">
            </el-option>
          </el-select>
        </fg-input>
      </div>
      <div class="col-12">
        <fg-input :placeholder="$t('settings.products.rules.labels.job_board')"
                  required
                  :label="$t('settings.products.rules.labels.job_board')"
                  :error="getError($t('settings.products.rules.labels.job_board'))">
          <el-select v-model="model.product_job_board_id"
                     v-validate="validations.required"
                     :name="$t('settings.products.rules.labels.job_board')"
                     class="select-default">
            <el-option v-for="product in productJobBoards"
                       :label="product.job_board.name"
                       :value="product.id"
                       :key="product.id"
                       class="select-default">
            </el-option>
          </el-select>
        </fg-input>
      </div>
      <div class="col-12">
        <label class="input-label">
          {{$t('settings.products.rules.labels.type')}}
        </label>
        <div class="radio-wrapper">
          <base-radio inline v-model="model.type" label="free">
            {{$t('settings.products.rules.labels.free')}}
          </base-radio>
          <base-radio inline v-model="model.type" label="discount">
            {{$t('settings.products.rules.labels.discount')}}
          </base-radio>
        </div>

      </div>
      <div class="col-12" v-if="model.type === 'discount'">
        <fg-input :placeholder="$t('settings.products.rules.labels.price')"
                  :label="$t('settings.products.rules.labels.price')"
                  :name="$t('settings.products.rules.labels.price')"
                  :error="getError($t('settings.products.rules.labels.price'))"
                  type="number"
                  v-validate="validations.price"
                  step="10"
                  v-model.number="model.price">
        </fg-input>
      </div>
      <div class="col-8 col-sm-6 col-md-4">
        <submit-button @click="submit"/>
      </div>

    </div>
  </form>
</template>
<script>
  import {Select, Option} from 'element-ui';
  import ProductService from 'src/services/ProductService'

  export default {
    name: 'product-rule-form',
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    props: {
      productRule: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        productJobBoards: [],
        products: [],
        model: {
          product_id: '',
          product_job_board_id: '',
          price: '',
          type: 'discount'
        },
        validations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async submit() {
        let res = await this.$validator.validateAll();
        if(res) {
          let data ={
            ...this.model
          };
          if(data.type === 'free') {
            delete data.price;
          }
          this.$emit('submit', data);
        }
      },
      async getProducts() {
        const {data} = await ProductService.get({ limit: 100 });
        this.products = data;
      },
      async getJobBoards(productId) {
        let path = `${productId}/job-boards?with=job_board`;
        let {data} = await ProductService.getJobBoards({limit: 100}, path)
        this.productJobBoards = data;
      }
    },
    async mounted() {
      this.$watch('productRule', newVal => {
        if (!newVal) {
          return
        }
          this.model = {
            ...this.model,
            ...newVal
          }
      }, { immediate: true});
      await this.getProducts();
      if(this.model.product_id) {
        await this.getJobBoards(this.model.product_id);
      }
    }
  }
</script>
<style>
</style>
